import { FunctionalComponent } from 'preact'
import { useCompanyTracking } from '@/hooks/useCompanyTracking'
import { TrackingSnippet } from './TrackingSnippet'

type TrackingPanelProps =
  | {
      scope: 'workspace'
      clientCompanyId: string
      workspaceId: string
      campaignId?: never
    }
  | {
      scope: 'campaign'
      clientCompanyId: string
      workspaceId: string
      campaignId: string
    }

const COPY = {
  workspace: {
    heading: 'Visitor Tracking',
    description: 'Install this snippet on pages where this workspace captures leads.',
    label: 'Workspace tracking snippet',
  },
  campaign: {
    heading: 'Visitor Tracking',
    description: 'Install this snippet on pages where this campaign captures leads.',
    label: 'Campaign tracking snippet',
  },
} as const

export const TrackingPanel: FunctionalComponent<TrackingPanelProps> = (props) => {
  const { tracking, isLoading, error } = useCompanyTracking(props.clientCompanyId)
  const copy = COPY[props.scope]

  return (
    <div className="bg-slate-50 dark:bg-slate-700/30 rounded-xl p-6 border border-slate-200 dark:border-slate-600">
      <h3 className="text-lg font-semibold text-slate-900 dark:text-white">{copy.heading}</h3>
      <p className="text-sm text-slate-600 dark:text-slate-300 mt-1 mb-4">{copy.description}</p>

      {isLoading && (
        <div className="h-20 rounded bg-slate-200 dark:bg-slate-600 animate-pulse" />
      )}

      {!isLoading && error && (
        <div className="text-sm text-red-600 dark:text-red-400">{error}</div>
      )}

      {!isLoading && !error && tracking && (
        <TrackingSnippet
          TrackingId={tracking.TrackingId}
          ScriptUrl={tracking.ScriptUrl}
          WorkspaceId={props.workspaceId}
          CampaignId={props.scope === 'campaign' ? props.campaignId : undefined}
          label={copy.label}
        />
      )}
    </div>
  )
}
